/**
 * Extracts token from the current URL
 * @returns {string|boolean} - The token if found, false otherwise
 */
export const getTokenFromUrl = () => {
  const url = window.location.href;
  const captured = /token=([^&]+)/.exec(url);

  if (captured && captured.length > 1) {
    return captured[1];
  }

  return false;
};

/**
 * Builds the API URL for customer search
 * @param {string} baseUrl - The base API URL
 * @param {string} token - The authentication token
 * @param {string} term - The search term
 * @param {number} offset - The pagination offset
 * @returns {string} - The complete API URL
 */
export const buildCustomerSearchUrl = (
  baseUrl,
  token,
  term = "",
  offset = 0
) => {
  return `${baseUrl}customers?token=${token}&q=${term}&offset=${offset}`;
};

/**
 * Formats conversation duration from seconds
 * @param {number} billsec - Duration in seconds
 * @returns {string} - Formatted duration string
 */
export const formatConversationDuration = (billsec) => {
  if (!billsec || billsec <= 0) return " - ";

  const minutes = Math.floor(billsec / 60);
  const seconds = billsec % 60;
  return `${minutes} minute si ${seconds} secunde`;
};

/**
 * Debounce function to limit the rate of function calls
 * @param {Function} func - The function to debounce
 * @param {number} delay - The delay in milliseconds
 * @returns {Function} - The debounced function
 */
export const debounce = (func, delay) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
};

export const formatDate = (dateString) => {
  try {
    return new Date(dateString).toLocaleString("ro-RO");
  } catch (error) {
    return dateString;
  }
};
